import { render, staticRenderFns } from "./AssignmentTaskPage.vue?vue&type=template&id=1b15f6df"
import script from "./AssignmentTaskPage.vue?vue&type=script&lang=js"
export * from "./AssignmentTaskPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports